import React, { useState, useEffect, useRef } from 'react';
// import { useHistory } from 'react-router-dom';
import { getusernameFromServer, postuserdataFromServer, deleteuserdataFromServer } from '../../services/usermaster';
// import { HttpClient } from '@angular/common/http';

import $ from 'jquery'; 
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';

const UsermasterComponent = () => {
  // const history = useHistory();
  const [userview, setUserview] = useState(true);
  const [cardTitle, setCardTitle] = useState("");
  const [objuser, setObjuser] = useState({
    user_id: 0,
    mail_id: "",
    department: "",
    reporting_manager: ""
  });
  const [userdata, setUserdata] = useState({});
  const [user_list, setUserList] = useState([]);
  const [active_list, setActiveList] = useState([]);
  const [user, setUser] = useState({});
  const [editBtnshow, setEditBtnshow] = useState(false);
  const [myform, setmyform] = useState(true);
  const [rowData, setrowData] = useState(null);

  const gridApiRef = useRef(null);



  var gridColumns = [
       
    { field: 'User Name', headerName: 'User Name', sortable: true, filter: true, resizable: true},
    { field: 'Mail ID', headerName: 'Mail ID', sortable: true, filter: true, resizable: true },
    { field: 'Department', headerName: 'Department', sortable: true, filter: true, resizable: true },
    { field: 'Reporting Manager', headerName: 'Reporting Manager', sortable: true, filter: true, resizable: true },
    {
      headerName: 'Delete',
      cellRendererFramework: (params) => (
        <button
          onClick={() => deleteuserdetail(params)}
          className="delete-button"
        >
          <i className="fa fa-trash" aria-hidden="true"></i>
        </button>
      ),
      width: 80,
    },
    
  ];
 

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('Userdtl')));
    setObjuser({ user_id: 0, mail_id: "", department: "", reporting_manager: "" });
    setUserview(true);
    getusernamelist();
  }, []);

  const getusernamelist = () => {
    const Indata = {
      user_id: user.user_id,
    };
    console.log("inputuser", Indata);
    var getFileUploadsList = getusernameFromServer();

    axios.get(getFileUploadsList[1], {params : Indata}, getFileUploadsList[0])
    .then((recieveddata) => {
      const tempresponsedata = recieveddata;
      console.log("userlistresponse---", tempresponsedata);
      setUserdata(tempresponsedata);
      setActiveList(tempresponsedata.active_list);
      setUserList(tempresponsedata.user_list);
   
    });
  };

  const getuserdetails = (param) => {
    const updatedUserList = user_list.map((item) => {
      if (item.user_id === param) {
        return { ...item, checkboxSelection: true };
      } else {
        return { ...item, checkboxSelection: false };
      }
    });
    setUserList(updatedUserList);

    const selectedItem = user_list.find((item) => item.user_id === param);
    setObjuser({
      ...objuser,
      mail_id: selectedItem.mail_id,
      department: selectedItem.department,
      reporting_manager: selectedItem.reporting_manager
    });
  };

  const list = () => {
    setUserview(true);
    getusernamelist();
  };

  const backlist = () => {
    setUserview(false);
    setObjuser({});
  };

  const saveuserdetails = () => {
    const Indata = {
      user_id: objuser.user_id,
      mail_id: objuser.mail_id
    };
    console.log("inputuser", Indata);
    var getFileUploadsList = postuserdataFromServer();

    axios.get(getFileUploadsList[1], {params : Indata}, getFileUploadsList[0])
    .then((recieveddata) => {
      const tempresponsedata = recieveddata;
      console.log("userresponse---", tempresponsedata);
      setObjuser({ user_id: 0, mail_id: "", department: "", reporting_manager: "" });
      setUserview(true);
    });
  };

  const cancelEdit = () => {
    // Implementation for canceling the edit operation
  };

  const deleteuserdetail = (param) => {
    const Indata = {
      user_id: param.user_id,
      mail_id: param.mail_id
    };
    console.log("inputuser", Indata);
    var getFileUploadsList = deleteuserdataFromServer();

    axios.get(getFileUploadsList[1], {params : Indata}, getFileUploadsList[0])
    .then((recieveddata) => {
      const tempresponsedata = recieveddata;
      console.log("userdeleteresponse---", tempresponsedata);
      getusernamelist();
    });
  };



  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <h4 className="page-title">Master</h4>
                  </li>
                  <li className="breadcrumb-item bcrumb-1">
                    <a href="../../Dashboard">
                      <i className="fa fa-home"></i> Home
                    </a>
                  </li>
                  <li className="breadcrumb-item active">User Master</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="">
                <form>
                  <div>
                    <h4 className="header d-flex justify-content-between">
                      {cardTitle}
                      <div className="col-12 text-right">
                        <button
                          type="button"
                          className="btn btn-raised btn-info btn-min-width mr-1 mb-1"
                          hidden={userview}
                          onClick={() => list()}
                        >
                          <i className="ft-package"></i> List
                        </button>

                        <button
                          type="button"
                          className="btn btn-raised btn-info btn-min-width mr-1 mb-1"
                          hidden={!userview}
                          onClick={() => backlist()}
                        >
                          <i className="ft-package"></i> Create
                        </button>
                      </div>
                    </h4>
                    <div className="body">
                      {!userview && (
                        <div>
                          <div className="row">
                            <div className="form-group col-md-4 mb-2">
                              <label htmlFor="userinput1">Name</label>
                              <select
                                className="custom-select form-control"
                                value={objuser.user_id}
                                onChange={(e) =>
                                  getuserdetails(e.target.value)
                                }
                                id="user_id"
                                name="user_id"
                                required
                                tabIndex="1"
                                data-validation-required-message="This Source Extension is required"
                              >
                                <option value="0">Select User</option>
                                {user_list.map((user) => (
                                  <option
                                    key={user.user_id}
                                    value={user.user_id}
                                  >
                                    {user.user_name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="form-group col-md-4 mb-2">
                              <label htmlFor="userinput1">User Name</label>
                              <input
                                type="text"
                                value={objuser.mail_id}
                                name="mail_id"
                                placeholder="User Name"
                                id="mail_id"
                                tabIndex="2"
                                className="form-control form-control-sm"
                                required
                                disabled
                              />
                            </div>
                            <div className="form-group col-md-4 mb-2">
                              <label htmlFor="userinput1">Department</label>
                              <input
                                type="text"
                                value={objuser.department}
                                name="department"
                                placeholder="Department"
                                id="department"
                                tabIndex="3"
                                className="form-control form-control-sm"
                                required
                                disabled
                              />
                            </div>
                            <div className="form-group col-md-4 mb-2">
                              <label htmlFor="userinput1">
                                Reporting Manager
                              </label>
                              <input
                                type="text"
                                value={objuser.reporting_manager}
                                name="reporting_manager"
                                placeholder="Reporting Manager"
                                id="reporting_manager"
                                tabIndex="4"
                                className="form-control form-control-sm"
                                required
                                disabled
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 text-right">
                              <button
                                type="button"
                                onClick={() => cancelEdit()}
                                hidden={!editBtnshow}
                                className="btn btn-outline-dark mr-1 btn-min-width mb-1"
                              >
                                Cancel
                              </button>

                              <button
                                type="submit"
                                className="btn btn-raised btn-info btn-min-width mr-1"
                                disabled={!myform.valid}
                                onClick={() => saveuserdetails()}
                              >
                                <i className="fa fa-check-square-o"></i> Generate
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </form>

                
              </div>
            </div>
          </div>
        </div>
      </section>

      {userview && (
                  <div className="ag-theme-balham report-layer" style={{width:'100%', heidght:'100%'}}>
                  <AgGridReact
                      columnDefs={gridColumns}
                      rowData={rowData}
                      paginationPageSize={20}
                      pagination={true}
                      animateRows={true}
                      rowSelection={'multiple'}
                      groupSelectsChildren={true}
                      ref={gridApiRef}
                      suppressAggAtRootLevel={true}
                      suppressRowClickSelection={true}
                      
                  >
                  </AgGridReact>
              </div>
                )}
    </div>
  );

};

export default UsermasterComponent;